<template>
  <h3 class="group-heading">{{mainDisplayText}}</h3>
</template>

<script>
import Component from 'vue-class-component'

import MetadataBase from './MetadataBase'

@Component({
})
export default class GroupHeading extends MetadataBase {
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/GroupHeading.vue